import React from "react";

function Footer() {
    return (
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logos">
            <a href="https://www.ua.pt/estga">
              <img
                src="imgs/estga_vertical_branco.png"
                alt="ESTGA"
                className="footer-logo"
              />
            </a>
            <a href="https://www.ua.pt/estga">
              <img
                src="imgs/estga_redes sociais_branco.png"
                alt="ESTGA"
                className="footer-small-logo"
              />
            </a>
          </div>
          <div className="footer-contact">
            <h3>Contatos</h3>
            <p>
              Escola Superior de Tecnologia e Gestão de Águeda da Universidade
              de Aveiro
            </p>
            <p>Rua Comandante Pinho e Freitas, nº 28</p>
            <p>3750 – 127 Águeda</p>
            <p>
              Email: <a href="mailto:estga.geral@ua.pt">estga.geral@ua.pt</a>
            </p>
            <p>Telefone: (+351) 234 611 500</p>
          </div>
        </div>
      </footer>
    );
}

export default Footer;